import React from 'react'

const ProfileCard = () => {
    return (
        <>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art2.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art2.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art2.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                <div className="_nft_settings_main_bottom_content">
                    <div className="_nft_settings_main_bottom_content_top">
                        <ul className="_nft_settings_main_bottom_content_top_ul">
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p3.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p2.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                            <li className="_nft_settings_main_bottom_content_top_li">
                                <img src="assets/img/p4.png" alt="bg" className="_nft_settings_main_bottom_content_top_img" />
                            </li>
                        </ul>
                        <div className="_nft_settings_main_bottom_content_top_more">
                            <button className="_nft_settings_main_bottom_content_top_more_btn">
                                <span className="_nft_settings_main_bottom_content_top_more_btn_ic">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 13 4">
                                        <path fill="#000" d="M2.137.314c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm9 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Zm-4.5 0c-.809 0-1.512.703-1.512 1.511 0 .809.703 1.512 1.512 1.512.808 0 1.512-.703 1.512-1.512 0-.808-.704-1.511-1.512-1.511Z" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_img_wrap">
                        <img src="assets/img/Art2.png" alt="asd" className="_nft_settings_main_bottom_content_img" />
                    </div>
                    <div className="_nft_settings_main_bottom_content_title_wrap">
                        <h3 className="_nft_settings_main_bottom_content_title">Election
                            Season</h3>
                        <div className="_nft_settings_main_bottom_content_title_img_wrap">
                            <img src="assets/img/chain7.png" alt="asd" className="_nft_settings_main_bottom_content_title_img" />
                            <p className="_nft_settings_main_bottom_content_p">
                                from <strong>159 Tron</strong>
                            </p>
                        </div>
                    </div>
                    <div className="_nft_settings_main_bottom_content_btn_wrap">
                        <button className="_nft_settings_main_bottom_content_btn">
                            Burn&amp;Mint
                        </button>
                        <button className="_nft_settings_main_bottom_content_btn _nft_settings_main_bottom_content_btn2">
                            <span className="_nft_settings_main_bottom_content_btn_ic">
                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" viewBox="0 0 16 15">
                                    <path fill="#000" d="M11.278.552c-1.3 0-2.566.598-3.375 1.582A4.415 4.415 0 0 0 4.53.552C2.209.552.415 2.381.415 4.666c0 2.847 2.531 5.168 6.399 8.683l1.09.95 1.09-.985c3.867-3.48 6.398-5.8 6.398-8.648 0-2.285-1.793-4.114-4.114-4.114ZM7.974 12.224l-.07.07-.07-.07C4.246 8.99 1.891 6.845 1.891 4.666c0-1.477 1.125-2.602 2.637-2.602 1.16 0 2.285.738 2.671 1.758h1.407c.386-1.02 1.511-1.758 2.671-1.758 1.512 0 2.637 1.125 2.637 2.602 0 2.18-2.355 4.324-5.941 7.558Z" />
                                </svg>
                            </span>
                            <span className="_nft_settings_main_bottom_content_btn_txt">
                                24
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfileCard;